<template>
  <Grid content-items="center" class="icon-wrapper" :class="{ dense }">
    <slot />
  </Grid>
</template>

<script>
export default {
  props: {
    dense: Boolean
  }
}
</script>

<style lang="scss" scoped>
.icon-wrapper {
  height: 100%;
  width: calc(var(--r-icon-size) + var(--r-space-sm) * 2);

  &.dense {
    width: calc(var(--r-icon-size) + var(--r-space-xs) * 2);
  }
}
</style>
